import { useMemo } from 'react'
import ConfigurableSections from '../../../../components/ConfigurableSections'
import useConditionalData from '../../../../hooks/useConditionalData'
import { createCommunitySectionsConfig } from './config/sectionsConfig'

import styles from './styles.module.scss'

const CommunityBody = ({ community }) => {
  const conditions = useConditionalData(community, {
    hasOrganizerLogo: 'organizerLogo',
    hasTeamOfOrganizer: 'teamOfOrganizer',
    hasContact: 'contact',
    hasPartnerLogo: 'partnerLogo',
    hasSponsorLogo: 'sponsorLogo',
    hasAnyPhotos: 'anyPhotos',
    hasDiscord: data => !!data?.socialNetworks?.discord,
    hasTwitter: data => !!data?.socialNetworks?.twitter,
    hasFacebook: data => !!data?.socialNetworks?.facebook,
    hasInstagram: data => !!data?.socialNetworks?.instagram,
  })

  const sectionsConfig = useMemo(
    () => createCommunitySectionsConfig(community, conditions, styles),
    [community, conditions]
  )

  return (
    <div className={styles.events__about__wrapper} data-testid='community-body'>
      <section className={styles.events__about}>
        <ConfigurableSections
          data={community}
          conditions={conditions}
          sections={sectionsConfig}
        />
      </section>
    </div>
  )
}

export default CommunityBody
